import Vue from 'vue'
import App from "@/app/App.vue";
import router from './router'
import store from './store'

Vue.config.productionTip = false

// VueI18n
import VueI18n from 'vue-i18n';
import i18n from '@/langs/i18n';
Vue.use(VueI18n);

// Bootstrap Vue
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

import { VueHammer } from 'vue2-hammer'
VueHammer.config = {
  pinch: {
    enable: true,
  },
  pan: {
    enable: true,
    threshold: 0
  },
  swipe: {
    threshold: 100000
  }
}
Vue.use(VueHammer)

// Vee validate
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import './utils/validation.util'
Vue.component("ValidationObserver", ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.config.errorHandler = function (err, vm: any, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log('Custom vue error handler: ', err, vm.name, info);
};
Vue.config.warnHandler = function (err, vm: any, info) {
  // handle error
  // `info` is a Vue-specific error info, e.g. which lifecycle hook
  // the error was found in. Only available in 2.2.0+
  console.log('Custom vue warn handler: ', err, vm.name, info);
};

// Prevent vue from spamming the console with "helpful" tips
Vue.config.productionTip = false;

import VueCookies from "vue-cookies"
Vue.use(VueCookies)

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
